'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateModal = undefined;

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateModal = exports.updateModal = function updateModal(data) {
  var id = data.name;

  var change = 'MODAL';
  var container = 'modal';

  var name = data.name,
      close = data.close;

  var active = close ? undefined : name;

  _state2.default.set({ id: id, change: change, active: active, container: container });
};